import React from 'react'
import { string } from 'prop-types'

import Container from 'components/atoms/Container'
import Row from 'components/atoms/Row'
import Col from 'components/atoms/Col'

import SectionContainer from 'components/atoms/SectionContainer'
import SectionTitle from 'components/atoms/SectionTitle'
import Markdown from 'components/atoms/MarkdownContent'

import config from 'config'

const { assets_url: assetsUrl } = config

const DescSection = ({ title, description }) => (
  <div id="description" className="scholarship-desc-section">
    <SectionContainer
      paddingTop={80}
      paddingBottom={120}
      backgroundColor="transparent"
    >
      <Container>
        <Row>
          <Col md={{ offset: 2, size: 8 }}>
            <div className="scholarship-desc-section__title">
              <SectionTitle title={title} />
            </div>
            <Markdown content={description}/>
          </Col>
        </Row>
      </Container>
    </SectionContainer>
    <style jsx>
      {`
        .scholarship-desc-section {
          background-color: #fff;
          background-image: url('${assetsUrl}/assets/img/blurry-accent.svg'), url('${assetsUrl}/assets/img/quarter-blur-oval.svg');
          background-position: top 15% left 0, bottom 0 right 0;
          background-repeat: no-repeat, no-repeat;
          &__title {
            text-align: center;
          }
        }
      `}
    </style>
  </div>
)

DescSection.propTypes = {
  title: string,
  description: string,
}

export default DescSection
